import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Button, { THEMES as BUTTON_THEMES } from 'src/components/HTKit/Forms/Button';
import EmptyState from 'src/components/EmptyState';
import styles from '../styles.scss';

const NoOrders = ({ onCtaButtonClick }) => {
  return (
    <article className={cn('site-v2', styles.noOrdersContainer)}>
      <EmptyState
        iconName="list"
        text="Click below to start booking!"
        title="You have no orders yet."
        showButton
        className={styles.emptyStateContainer}
      >
        <Button onClick={onCtaButtonClick} theme={BUTTON_THEMES.V2SECONDARY} type="button" mediumV2>
          Book a Service
        </Button>
      </EmptyState>
    </article>
  );
};

NoOrders.propTypes = {
  onCtaButtonClick: PropTypes.func.isRequired,
};

export default NoOrders;
